import { render, staticRenderFns } from "./register-search.vue?vue&type=template&id=0833897a&scoped=true&"
import script from "./register-search.vue?vue&type=script&lang=js&"
export * from "./register-search.vue?vue&type=script&lang=js&"
import style0 from "./register-search.vue?vue&type=style&index=0&id=0833897a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0833897a",
  null
  
)

export default component.exports